import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react'

import i18n from '@batical/i18n'
import { InputAdornment } from '@mui/material'
import { FaChevronRight } from 'react-icons/fa'

import { ViewLine, CalculText, CalculTextInput, ViewDisclosure } from './LineStyleComponent'
import { textFont } from '../Fonts'
import { textBasicSize } from '../Metrics'
import { Text } from '../Native/Text'

const isDouble = (value: unknown) => {
  return typeof value === 'number' || value instanceof Number
}
export type TextInputLineManualProps = {
  title: string
  /**
   * Unit value to display
   *
   * @type {string}
   */
  unit?: string
  /**
   * Should show a disclosure button on right side
   *
   * @type {boolean}
   */
  disclosure?: boolean

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDisclosurePress?: (value: number, meta: any) => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  image?: any
  /**
   * Input Value can be negative
   *
   * @type {boolean}
   */
  negativeValue?: boolean
  value: number
  /**
   * action to do on change value
   *
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (number: number, extra?: any) => void
  textColor?: string
  extraParam?: Object //category can be used for disclosure, additional parameter for on change on disclosure
  /**
   * launch calcul
   *
   * @type {boolean}
   */
  doCalcul?: boolean
  /**
   *
   * if true element is the first
   * @type {boolean}
   */
  first?: boolean
  /**
   *
   *if true element is the last
   * @type {boolean}
   */
  last?: boolean
  disable?: boolean
}

const TextInputLineManual = ({
  value,
  unit,
  disclosure = false,
  onDisclosurePress,
  onChange,
  extraParam = undefined,
  title,
  textColor,
  first = false,
  last = false,
  disable = false
}: TextInputLineManualProps) => {
  const textInputRef = useRef(null)
  const [inputVal, setInputVal] = useState('0')

  const text = useMemo(() => {
    let tex = ''
    if (title) {
      tex = i18n.t(title)
    }

    return tex
  }, [title])

  useEffect(() => {
    if (isDouble(value)) {
      setInputVal(String(+value))
    }
  }, [value])

  const _onEndEditing = useCallback(() => {
    const result = parseFloat(inputVal.replace(',', '.'))
    if (isNaN(result)) {
      setInputVal(String(+value))
      onChange(0, extraParam)
    } else if (String(value) === inputVal) {
      // console.error('textinputline, I donw now why this condition but should not happen')
      // i saw it happen so it is required but did not analyse why

      onChange(value, extraParam)

      setInputVal(inputVal)
    } else {
      onChange(result, extraParam)
    }
  }, [extraParam, inputVal, onChange, value])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const _onChangeText = useCallback((event: any) => {
    setInputVal(event.target.value)
  }, [])

  const onFocus = useCallback(() => {
    setInputVal('')
  }, [])

  const onKeypress = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e: any) => {
      if (e.key === 'Enter') {
        _onEndEditing()
      }
    },
    [_onEndEditing]
  )

  const _onTouchCell = useCallback(() => {
    if (onDisclosurePress != null) {
      let val = 0 || parseFloat(inputVal.replace(',', '.'))
      onDisclosurePress(val, extraParam)
    } else {
      // @ts-ignore
      textInputRef?.current?.focus()
    }
  }, [extraParam, inputVal, onDisclosurePress])
  return (
    <ViewLine first={first} last={last} onClick={_onTouchCell}>
      {/* {image && <ViewLineImage src={image} />} */}
      <CalculText>{text}</CalculText>
      <ViewDisclosure>
        <CalculTextInput
          ref={textInputRef}
          value={inputVal}
          onFocus={onFocus}
          onChange={_onChangeText}
          onKeyPress={onKeypress}
          onBlur={_onEndEditing}
          variant="outlined"
          size="small"
          disabled={disable}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" sx={{ color: textColor, fontSize: textBasicSize, fontFamily: textFont }}>
                <Text>{unit}</Text>
              </InputAdornment>
            )
          }}
        />

        {disclosure && <FaChevronRight color="#808080" size={25} />}
      </ViewDisclosure>
    </ViewLine>
  )
}

export default memo(TextInputLineManual)
